import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    parseStatus,
    formatterDateToUTC
} from "@/util/util";
import {
    baseUrl
} from '@/config/env';


export const projectDynamicOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "工程项目名称",
            prop: "name",
            type: 'input',
            search: true,
            span: 13,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
        },
        /* {
            label: "工程阶段数",
            prop: "num",
            type: 'input',
            span: 13,
        },
        {
            label: "工程项目名称",
            search: true,
            prop: "engineeringProjectName",
            type: 'input',
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "动态表单数",
            prop: "dynamicNum",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false,
        }, */
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            formatter: function (row, value, label, column) {
                return formatterDateToUTC(row.createTime * 1)
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};